var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-form-model',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules}},[_c('a-form-model-item',{attrs:{"has-feedback":"","label":"Tên","prop":"name"}},[_c('a-input',{attrs:{"placeholder":"Nhập tên"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_c('a-form-model-item',{attrs:{"label":"Người dùng","prop":"userIds"}},[_c('SelectUser',{attrs:{"selectProps":{
          value: _vm.form.userIds,
          placeholder: 'Chọn người dùng',
          mode: 'multiple',
        },"variablesQuery":{
          hasEmployee: false,
        }},model:{value:(_vm.form.userIds),callback:function ($$v) {_vm.$set(_vm.form, "userIds", $$v)},expression:"form.userIds"}})],1)],1),_c('div',{staticStyle:{"text-align":"right"},style:({
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    })},[_c('a-button',{staticStyle:{"margin-right":"5px"},attrs:{"icon":"close"},on:{"click":_vm.closeDrawerAdd}},[_vm._v(" Đóng ")]),_c('a-button',{attrs:{"type":"primary","loading":_vm.iconLoading,"icon":"plus"},on:{"click":function($event){return _vm.create()}}},[_vm._v(" Thêm mới ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }